/**
 * Gets shipment entries based on the provided `type`
 * @param shipments {array}
 * @param type {enum}
 */
const extractEntries = <T1, T2>(shipments: T1, type: T2) =>
  ((shipments || []) as any[]).filter(({ shipmentType }: any) => shipmentType === type)[0] || {};

export default extractEntries;
